module.exports = __webpack_public_path__ + "img/content-with-img-links-nissan.ecfb3f85.jpg";